import { jwtDecode } from "jwt-decode";
import axiosInstance from "../api/utils/axiosInstance";

// ------------- Language -----------------

const saveLanguagePreference = (language) => {
  localStorage.setItem("language", language);
};

const getLanguagePreference = () => {
  return localStorage.getItem("i18nextLng");
};

const removeLanguagePreference = () => {
  localStorage.removeItem("i18nextLng");
};

// ------------- Credentials -----------------

const setCredsInLocalStorage = ({ token, refresh }) => {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
  localStorage.setItem("access", JSON.stringify(token));
  localStorage.setItem("refresh", JSON.stringify(refresh));
};

const removeCredsFromLocalStorage = () => {
  delete axiosInstance.defaults.headers.common["Authorization"];
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
};

const getCredsFromLocalStorage = () => ({
  token: JSON.parse(localStorage.getItem("access")),
  refresh: JSON.parse(localStorage.getItem("refresh")),
});

// UMS claims (role_ids, perm_ids, team_ids, group_ids, active_role, ...)
// are embedded in the access token itself rather than returned as separate
// response fields — decode on demand instead of duplicating them in storage.
const getDecodedClaims = () => {
  const { token } = getCredsFromLocalStorage();
  if (!token) return null;
  return jwtDecode(token);
};

// The backend has no "active team" concept (only active role) — current
// team is purely client-side UI state, persisted so it survives reloads.
const getPersistedTeamId = () => {
  return JSON.parse(localStorage.getItem("currentTeamId") ?? "null");
};

const setPersistedTeamId = (teamId) => {
  localStorage.setItem("currentTeamId", JSON.stringify(teamId ?? null));
};

// ------------- OPEKEPE -----------------

const saveOpekepeRedirectUrl = (path) => {
  localStorage.setItem("opekepeRedirectUrl", path);
};

const getOpekepeRedirectUrl = () => {
  const url = localStorage.getItem("opekepeRedirectUrl");
  localStorage.removeItem("opekepeRedirectUrl");
  return url;
};

const saveOpekepeLoginCode = (code) => {
  localStorage.setItem("opekepeLoginCode", code);
};
const readOpekepeLoginCode = () => {
  return localStorage.getItem("opekepeLoginCode");
};
const getOpekepeLoginCode = () => {
  const code = localStorage.getItem("opekepeLoginCode");
  localStorage.removeItem("opekepeLoginCode");
  return code;
};

const saveSyncedUser = (user) => {
  localStorage.setItem("opekepeSyncUser", JSON.stringify(user));
};
const readSyncedUser = () => {
  let user = localStorage.getItem("opekepeSyncUser");
  user = JSON.parse(user);
  return user;
};
const getSyncedUser = () => {
  let user = localStorage.getItem("opekepeSyncUser");
  user = JSON.parse(user);
  localStorage.removeItem("opekepeSyncUser");
  return user;
};

// ------------- Read Application Year Note -----------------

const readApplicationYearNote = (year) => {
  localStorage.setItem("applicationYearNoteIsRead", year);
};

const clearApplicationYearNoteReadState = () => {
  localStorage.removeItem("applicationYearNoteIsRead");
};

const checkIfApplicationYearNoteIsRead = (year) => {
  const isLatestRead =
    localStorage.getItem("applicationYearNoteIsRead") === year;

  if (!isLatestRead) {
    clearApplicationYearNoteReadState();
  }
  return isLatestRead;
};

export const storage = {
  saveLanguagePreference,
  saveOpekepeRedirectUrl,
  getOpekepeRedirectUrl,
  getLanguagePreference,
  removeLanguagePreference,
  setCredsInLocalStorage,
  removeCredsFromLocalStorage,
  getCredsFromLocalStorage,
  getDecodedClaims,
  getPersistedTeamId,
  setPersistedTeamId,
  saveOpekepeLoginCode,
  getOpekepeLoginCode,
  readOpekepeLoginCode,
  saveSyncedUser,
  readSyncedUser,
  getSyncedUser,
  readApplicationYearNote,
  checkIfApplicationYearNoteIsRead,
  clearApplicationYearNoteReadState,
};
